import { datadogRum } from "@datadog/browser-rum";
import { getTrafficguiBaseUrl } from "api/common";
import { useUserInfoStore } from "app/Auth/useUserInfoStore";
import { Environment, environment } from "app/environment/environment";
import { useEffect, useState } from "react";
import { useDropsRole } from "stores/useDropsRole";

const version: string | undefined = import.meta.env.APP_VERSION;

// Enable RUM for these environments
const enabledEnvironments: Environment[] = [
  /* Disabled for now */
];

export const useDatadogRum = () => {
  const { role } = useDropsRole();
  const { userInfo } = useUserInfoStore();

  const env = environment();
  const apiBaseUrl = getTrafficguiBaseUrl();

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!isInitialized && version && enabledEnvironments.includes(env)) {
      datadogRum.init({
        applicationId: "3600d048-b425-4982-bd42-128cdc394624",
        clientToken: "pub8ee527512847fa15aade4e1f59fb577e",
        site: "datadoghq.eu",
        service: "drops-frontend",
        env: env.toLowerCase(),
        version: version.toString(),
        traceSampleRate: 100,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: "mask", // Masks all HTML text, user input, images, links and data-* attributes.
        allowedTracingUrls: [(url) => url.startsWith(apiBaseUrl)],
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        trackAnonymousUser: true,
      });
      setIsInitialized(true);
    } else if (!isInitialized) {
      // eslint-disable-next-line no-console
      console.info(`Datadog RUM not initialized for environment: ${env}`);
    }
  }, [env, isInitialized]);

  useEffect(() => {
    const userEmail = userInfo?.email;

    if (isInitialized && userEmail && role) {
      datadogRum.setUser({
        id: userEmail,
        role: role.toString(),
      });
    }
  }, [userInfo?.email, role, isInitialized]);
};
